import { render, staticRenderFns } from "./softwarePlatform.vue?vue&type=template&id=d223b150&scoped=true&"
import script from "./softwarePlatform.vue?vue&type=script&lang=js&"
export * from "./softwarePlatform.vue?vue&type=script&lang=js&"
import style0 from "./softwarePlatform.vue?vue&type=style&index=0&id=d223b150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d223b150",
  null
  
)

export default component.exports